const slovak = {
    'PHOTO_SOURCE.TakePhoto' : 'Odfotiť',
    'PHOTO_SOURCE.ChooseFromGallery' : 'Vybrať z galérie',
    'CRAFT.Type_Logistics' : 'Logistika { number }',
    'CRAFT.Type_Floor' : 'Podlaha { number }',
    'CRAFT.Type_Assembly' : 'Montáž { number }',
    'CRAFT.Type_Electrics' : 'Elektro { number }',
    'CRAFT.Type_Graphic' : 'Grafika { number }',
    'CRAFT.Type_Furniture' : 'Nábytok { number }',
    'CRAFT.Type_Multimedia' : 'Multimédiá { number }',
    'CRAFT.Type_Cleaning' : 'Upratovanie { number }',
    'CRAFT.Type_Additional' : 'Dodatočné { number }',
    'CRAFT.Type_MPControl' : 'MP kontrola',
    'CRAFT.Type_Protocol' : 'Protokol',
    'CRAFT.Type_Service' : 'Servis { number }',
    'CRAFT.Type_CollectGraphics' : 'Vyzdvihnúť grafiku',
    'CRAFT.Status_Text_InProgress' : 'Prebieha',
    'CRAFT.Status_Text_Disabled' : 'Vypnuté',
    'CRAFT.Status_Text_Completed' : 'Dokončené',
    'CRAFT.Status_Text_Overdue' : 'Po termíne',
    'CRAFT.Status_Text_Done' : 'Vyzdvihnuté',
    'CRAFT.Status_Text_Open' : 'Otvorené',
    'CRAFT.Status_Text_Collected': 'Vyzdvihnuté',
    'CRAFT.Status_Warning_Cannot_Change_Done': 'Stav nie je možné zmeniť: grafika už bola spracovaná v administrácii',
    'CRAFT.Button_ViewAll' : 'Zobraziť všetko',
    'CRAFT.Button_Text_Print' : 'Tlačiť',
    'CRAFT.Button_Text_Stand' : 'Stánok',
    'CRAFT.Button_Text_MarkOpen' : 'Označiť prácu ako otvorenú',
    'CRAFT.Button_Text_MarkDone' : 'Označiť prácu ako hotovú',
    'CRAFT.Button_Text_MarkInProgress' : 'Označiť prácu ako prebiehajúcu',
    'CRAFT.Button_ChangeStatus_InProgress' : 'Prebieha',
    'CRAFT.Button_ChangeStatus_Done': 'Hotovo',
    'CRAFT.Button_Text_ShelfNumber' : 'Č. police',
    'CRAFT.Filter_Params_CraftType' : 'Práce: { withFilter }',
    'EXHIBITION.Select_Instruction' : 'Vyberte podujatie { br } zo zoznamu nižšie',
    'EXHIBITION.Select_Label' : 'VYBRANÉ PODUJATIE',
    'EXHIBITION.Modal_Title' : 'VYBERTE PODUJATIE',
    'EXHIBITION.Timer_State_Underway' : 'PREBIEHA',
    'EXHIBITION.Timer_State_Ended' : 'UKONČENÉ',
    'EXHIBITION.Title_CraftTotal' : 'Prehľad všetkých prác',
    'EXHIBITION.Statistic_Status_InTotal' : 'celkom',
    'EXHIBITION.Statistic_Status_InProgress' : 'prebieha',
    'EXHIBITION.Statistic_Status_Done' : 'hotovo',
    'EXHIBITION.Statistic_Status_Overdue' : 'po termíne',
    'EXHIBITION.Statistic_Status_NotApproved' : 'neschválené',
    'EXHIBITION.Statistic_Status_BookedForExhibition' : 'priradení k výstave',
    'EXHIBITION.Statistic_Status_CheckedIn' : 'Prihlásení',
    'EXHIBITION.Statistic_Type_Stands' : 'Stánky',
    'EXHIBITION.Statistic_Type_Claims' : 'MP reklamácie',
    'EXHIBITION.Statistic_Type_CustomerClaims' : 'Reklamácie vystavovateľa',
    'EXHIBITION.Statistic_Type_LastMinute' : 'Urgentné úlohy',
    'EXHIBITION.Statistic_Type_MpControl' : 'MP kontrola',
    'EXHIBITION.Statistic_Type_Damages' : 'Škody',
    'EXHIBITION.Statistic_Type_Protocol' : 'Protokol',
    'EXHIBITION.Statistic_Type_Staff' : 'Personál',
    'FORM.Textarea_Placeholder_JobDescription' : 'Popis úlohy*',
    'FORM.Button_Text_AddJob' : 'Pridať úlohu',
    'FORM.Button_Text_SaveJob' : 'Uložiť úlohu',
    'FORM.Button_AddJobPhoto' : 'Pridať fotku',
    'FORM_RULES.Required_Login' : 'Zadajte login',
    'FORM_RULES.Required_Password' : 'Zadajte heslo',
    'FORM_RULES.Required_KeyDescription' : 'Zadajte popis kľúča',
    'FORM_RULES.Required_KeyNumber' : 'Zadajte číslo kľúča',
    'FORM_RULES.Required_JobDescription' : 'Pridajte popis úlohy',
    'FORM_RULES.Required_Quantity' : 'Zadajte množstvo',
    'FORM_RULES.Min_Quantity' : 'Množstvo musí byť číslo najmenej jedna',
    'FORMS.Input_Label_Login' : 'login',
    'FORMS.Input_Label_Password' : 'heslo',
    'FORMS.Button_Text_Login' : 'Prihlásiť',
    'FORMS.Input_Label_Description' : 'Popis',
    'FORMS.Input_Label_KeyNumber' : 'Číslo kľúča',
    'FORMS.Input_Label_Hall' : 'Hala',
    'FORMS.Input_Label_Stands' : 'Stánky',
    'FORMS.Button_Text_ApplyFilters' : 'Použiť',
    'FORMS.Button_Text_ResetFilters' : 'Resetovať filtre',
    'FORMS.Select_DefaultValue_All' : 'Všetko',
    'FORMS.Select_StandTypeValue_CraftInProgress' : 'S prebiehajúcimi prácami',
    'FORMS.Select_StandTypeValue_CraftCompleted' : 'S dokončenými prácami',
    'FORMS.Select_StandTypeValue_ControlInProgress' : 'S prebiehajúcou kontrolou',
    'FORMS.Select_StandTypeValue_ProtocolInProgress' : 'S prebiehajúcim protokolom',
    'FORMS.Select_StandTypeValue_OverdueCrafts' : 'S prácami po termíne',
    'FORMS.Select_StandTypeValue_AdditionalJobs' : 'S dodatočnými úlohami',
    'FORMS.Button_Text_ApplySort' : 'Použiť',
    'FORMS.Input_Label_CraftType' : 'Typ práce',
    'FORMS.Input_Label_JobType'   : 'Typ',
    'FORMS.Input_Label_JobFlag'   : 'Príznak',
    'FORMS.Input_Label_JobStatus' : 'Stav',
    'FORMS.Input_Label_CraftStatus' : 'Stav prác',
    'FORMS.Input_Label_DamageStatus' : 'Stav škody',
    'FORMS.Input_Label_Subcontractor' : 'Subdodávateľ',
    'FORMS.Input_Label_Comments' : 'Komentáre',
    'FORMS.Select_JobStatusValue_JobsOpen' : 'Otvorené úlohy',
    'FORMS.Select_JobStatusValue_JobsInProgress' : 'Prebiehajúce úlohy',
    'FORMS.Select_JobStatusValue_FinishedJobs' : 'Dokončené úlohy',
    'FORMS.Select_JobFlag_WithoutFlag' : 'Bez príznaku',
    'FORMS.Select_JobFlag_WithFlag' : 'S príznakom',
    'FORMS.Input_Label_FurnishingName' : 'Názov vybavenia',
    'FORMS.Input_Label_FurnishingReturnQuantity' : 'Množstvo',
    'FORMS.Input_Label_Quantity' : 'Množstvo',
    'FORMS.Input_Label_CurrentQuantity' : 'Aktuálne množstvo',
    'FORMS.Input_Label_NewQuantity' : 'Nové množstvo',
    'FORMS.RadioInput_Text_Description' : 'Popis',
    'FORMS.RadioInput_Text_Furnishing' : 'Vybavenie',
    'FORMS.RadioInput_Text_FurnishingClaim' : 'Vybavenie',
    'FORMS.Input_Label_OrderType'   : 'Typ',
    'FORMS.Select_FurnishingOrder_Type_Return' : "Vrátenie položky",
    'FORMS.Select_FurnishingOrder_Type_Lost' : "Stratené",
    'FORMS.Select_FurnishingOrder_Type_Correction' : "Zmena súčtu",
    'FORMS.Select_FurnishingOrder_Type_Order' : "Objednávka",
    'GLOBAL.Button_Text_Logout' : 'Odhlásiť',
    'GLOBAL.Button_Text_Filter' : 'Filter',
    'GLOBAL.Button_Text_Sort' : 'Zoradiť',
    'GLOBAL.Text_Version' : 'Verzia { versionNumber }',
    'GLOBAL.Button_Text_Cancel' : 'Zrušiť',
    'ATTENDANCE.Button_CheckIn': 'Príchod',
    'ATTENDANCE.Button_CheckOut': 'Odchod',
    'ATTENDANCE.SelectExhibitionFirst_Text': 'Najprv vyberte výstavu.',
    'ATTENDANCE.Button_RetryScan': 'Skenovať znova',
    'ATTENDANCE.Button_Close': 'Zavrieť',
    'ATTENDANCE.Modal_Title_CheckIn': 'Skenovať príchod',
    'ATTENDANCE.Modal_Title_CheckOut': 'Skenovať odchod',
    'ATTENDANCE.Scanner_Hint': 'Namierte kameru na QR kód',
    'ATTENDANCE.Processing_Locating_Title': 'Kontroluje sa poloha...',
    'ATTENDANCE.Processing_Locating_Text': 'Čakajte prosím. Hľadá sa GPS.',
    'ATTENDANCE.Processing_Submitting_Title': 'Odosiela sa sken...',
    'ATTENDANCE.Processing_Submitting_Text': 'Čakajte prosím. Ukladá sa pracovný čas.',
    'ATTENDANCE.Error_GpsPermission_Title': 'Vyžaduje sa prístup k polohe',
    'ATTENDANCE.Error_GpsPermission_Text': 'Povoľte prístup k polohe v prehliadači a skúste to znova.',
    'ATTENDANCE.Error_GpsTimeout_Title': 'Slabý GPS signál',
    'ATTENDANCE.Error_GpsTimeout_Text': 'Súradnice sa nepodarilo zistiť. Choďte bližšie k východu a skenujte znova.',
    'ATTENDANCE.Error_GpsUnavailable_Title': 'GPS nie je dostupné',
    'ATTENDANCE.Error_GpsUnavailable_Text': 'Údaje o polohe nie sú na tomto zariadení dostupné.',
    'ATTENDANCE.Error_Camera_Title': 'Kamera nie je dostupná',
    'ATTENDANCE.Error_Camera_Text': 'Povoľte prístup ku kamere a skúste to znova.',
    'ATTENDANCE.Error_CameraPermission_Title': 'Prístup ku kamere je zablokovaný',
    'ATTENDANCE.Error_CameraPermission_Text': 'Povoľte prístup ku kamere v nastaveniach stránky v prehliadači a skúste to znova.',
    'ATTENDANCE.Error_CameraNotFound_Title': 'Kamera sa nenašla',
    'ATTENDANCE.Error_CameraNotFound_Text': 'Toto zariadenie neposkytuje prehliadaču dostupnú kameru.',
    'ATTENDANCE.Error_SecureContext_Title': 'Vyžaduje sa HTTPS',
    'ATTENDANCE.Error_SecureContext_Text': 'Kamera a GPS v mobilnom prehliadači fungujú iba cez HTTPS. Otvorte aplikáciu cez HTTPS/dev tunnel.',
    'ATTENDANCE.Error_Server_Title': 'Sken zlyhal',
    'ATTENDANCE.Error_Server_Text': 'Server sken nespracoval. Skontrolujte internetové pripojenie a skúste to znova.',
    'ATTENDANCE.Error_Generic_Title': 'Sken zlyhal',
    'ATTENDANCE.Error_Generic_Text': 'Skúste to znova.',
    'ATTENDANCE.Result_CheckInAccepted_Title': 'Príchod úspešný',
    'ATTENDANCE.Result_CheckOutAccepted_Title': 'Odchod úspešný',
    'ATTENDANCE.Result_Accepted_Text': 'Čas: { serverTime }. Ste zaznamenaný v systéme.',
    'ATTENDANCE.Result_Duplicate_Title': 'Už zaznamenané',
    'ATTENDANCE.Result_Duplicate_Text': 'Tento sken už bol uložený.',
    'ATTENDANCE.Result_Rejected_Title': 'Prístup zamietnutý',
    'ATTENDANCE.Result_OutsideRadius_Text': 'Ste príliš ďaleko od vchodu. Choďte bližšie ku vchodu.',
    'ATTENDANCE.Result_InvalidQr_Text': 'Tento QR kód nie je platný pre príchod/odchod.',
    'ATTENDANCE.Result_GenericRejected_Text': 'Sken bol zamietnutý.',
    'ATTENDANCE.Button_Back': 'Späť',
    'ATTENDANCE.Button_TryAgain': 'Skúsiť znova',
    'ATTENDANCE.Button_GotIt': 'Rozumiem',
    'ATTENDANCE.Overview_NotCheckedIn': 'Príchod nie je zaznamenaný',
    'ATTENDANCE.Overview_CheckInPrompt': 'Zaznamenajte príchod pomocou QR kódu',
    'ATTENDANCE.Overview_CheckedIn_Label': 'Príchod zaznamenaný',
    'ATTENDANCE.Overview_CheckedInAt': 'o { time }',
    'ATTENDANCE.Scanner_CheckIn_Hint': 'Pred začatím práce naskenujte QR kód na zaznamenanie príchodu',
    'ATTENDANCE.Scanner_CheckOut_Hint': 'Pre odchod namierte kameru na QR kód na výstave',
    'ATTENDANCE.Error_StatusLoad_Text': 'Stav príchodu sa nepodarilo načítať.',
    'ATTENDANCE.Error_CameraDesign_Title': 'Aplikácia nemôže otvoriť kameru',
    'ATTENDANCE.Error_CameraDesign_Text': 'Pre príchod naskenujte kód kamerou telefónu. Klepnite na Skúsiť znova a povoľte prístup ku kamere.',
    'ATTENDANCE.Error_Camera_Settings_Hint': 'Stále to nefunguje? Skontrolujte povolenie kamery v nastavení prehliadača.',
    'ATTENDANCE.Error_LocationDesign_Title': 'Aplikácia nevidí vašu polohu',
    'ATTENDANCE.Error_LocationDesign_Text': 'Na potvrdenie prítomnosti je potrebná poloha. Zapnite ju v nastavení telefónu a skúste to znova.',
    'ATTENDANCE.Result_CheckedInAt': 'Príchod zaznamenaný dňa { date }. o { time }',
    'ATTENDANCE.Result_CheckInSuccessAt': 'Príchod do práce bol úspešne zaznamenaný o { time }.',
    'ATTENDANCE.Result_CheckedOutAt': 'Prácu ste ukončili a odchod{ br }zaznamenali o { time }',
    'ATTENDANCE.Result_OutsideRadius_Title': 'Musíte byť na mieste podujatia',
    'ATTENDANCE.Result_OutsideRadius_DesignText': 'Vaša poloha nezodpovedá výstave. Príchody sa zaznamenávajú pomocou GPS. Skúste to znova na správnom mieste.',
    'ATTENDANCE.Result_InvalidQr_Title': 'Toto nie je správny kód',
    'ATTENDANCE.Result_InvalidQr_CheckIn_Title': 'Príchod nie je možné zaznamenať!',
    'ATTENDANCE.Result_InvalidQr_CheckOut_Title': 'Odchod nie je možné zaznamenať!',
    'ATTENDANCE.Result_InvalidQr_DesignText': 'Tento QR kód nepatrí k vášmu podujatiu. Obráťte sa, prosím, na vedenie stavby alebo projektu.',
    'ATTENDANCE.Result_DeviceConflict_Title': 'Príchod nie je možné zaznamenať!',
    'ATTENDANCE.Result_DeviceConflict_Text': 'Iná osoba už pomocou tohto telefónu zaznamenala svoj príchod. Aplikácia neumožňuje dvom rôznym používateľom zaznamenať príchod pomocou toho istého zariadenia!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Title': 'Skenovanie príchodu nie je možné!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Text': 'Príchod je možné zaznamenať iba počas stanoveného obdobia konania podujatia. Obráťte sa, prosím, na vedenie stavby alebo projektu.',
    'ATTENDANCE.Result_OutsideSchedule_CheckOut_Title': 'Odchod momentálne nie je možné zaznamenať',
    'ATTENDANCE.Result_OutsideSchedule_Text': 'Táto akcia je dostupná iba počas nastaveného obdobia výstavy. Skontrolujte vybranú výstavu a jej dátumy.',
    'ATTENDANCE.TimeRecords_InProgress': 'prebieha',
    'ATTENDANCE.TimeRecords_Missed': 'chýba',
    'ATTENDANCE.TimeRecords_Empty': 'Zatiaľ nie sú žiadne časové záznamy.',
    'ATTENDANCE.Error_TimeRecordsLoad_Text': 'Časové záznamy sa nepodarilo načítať.',
    'MENUS.Label_MyTimeRecords': 'Moje časové záznamy',
    'PAGE.Title_MyTimeRecords': 'Moje časové záznamy',
    'GLOBAL.Badge_Text_New' : 'NOVÉ',
    'GLOBAL.Modal_Title_Filters' : 'Filtre',
    'GLOBAL.Modal_Title_SortBy' : 'Zoradiť podľa',
    'GLOBAL.TimeLeft' : 'zostáva { timeLeft }',
    'GLOBAL.Text_Piece' : 'ks',
    'GLOBAL.Button_Text_Confirm' : 'Potvrdiť',
    'GLOBAL.Language_Default' : 'Predvolené',
    'TRANSLATION.Button_Text_Translate' : 'Preložiť',
    'TRANSLATION.Button_Text_TranslateInput' : 'Preložiť do nemčiny',
    'TRANSLATION.Button_Text_TranslateEnglish' : 'Preložiť do angličtiny',
    'TRANSLATION.Button_Text_TranslateNative' : 'Preložiť do môjho jazyka',
    'TRANSLATION.Button_Text_ShowOriginal' : 'Zobraziť nemecký originál',
    'TRANSLATION.Text_InputTranslating' : 'Prekladá sa...',
    'TRANSLATION.Text_InputTranslated' : 'Preložené',
    'TRANSLATION.Text_InputTranslationError' : 'Preklad zlyhal',
    'TRANSLATION.Text_InputTranslationRequired' : 'Pred odoslaním text preložte',
    'TRANSLATION.Text_ApiUnavailable' : 'Preklad teraz nie je dostupný',
    'GLOBAL.Card_Hero_Hall' : 'Hala',
    'GLOBAL.Card_Hero_Block' : 'Blok',
    'GLOBAL.Card_Hero_Stand' : 'Stánok',
    'GLOBAL.Comment': 'Komentár',
    'HALL.Button_Text_HallPlan' : 'Plán haly',
    'HALL.Link_Text_HallPlan' : 'Plán haly { hallName }',
    'JOB.Tag_Claim' : 'C',
    'JOB.Tag_CustomerClaim' : 'C',
    'JOB.Tag_MPAndCustomerClaim' : 'C',
    'JOB.Tag_LastMinute' : 'LM',
    'JOB.Tag_Damage' : 'D',
    'JOB.Tag_ProtocolDefect' : 'PD',
    'JOB.Card_Hero_Hall' : 'Hala',
    'JOB.Card_Hero_Number' : 'Č. úlohy',
    'JOB.Card_Hero_Block' : 'Blok',
    'JOB.Card_Hero_Stand' : 'Stánok',
    'JOB.Card_Hero_Exhibitor' : 'Vystavovateľ',
    'JOB.Button_Text_ToTheStand' : 'K stánku',
    'JOB.Text_Creator' : 'od { whoCreate } dňa { whenCreate }',
    'JOB.Text_InWork' : 'od { whoWork } dňa { whenWork }',
    'JOB.Text_Executor' : 'od { whoExecute } dňa { whenExecute }',
    'JOB.Text_DurationTime' : 'Trvanie: { time }',
    'JOB.Type_Claim' : 'MP reklamácia',
    'JOB.Type_AllClaims' : 'Reklamácia',
    'JOB.Type_CustomerClaim' : 'Reklamácia vystavovateľa',
    'JOB.Type_LastMinute' : 'Urgentná úloha',
    'JOB.Type_Damage' : 'Škoda',
    'JOB.Type_ProtocolDefect' : 'Vada v protokole',
    'JOB.Button_ChangeStatus_Waiting' : 'Prevziať úlohu',
    'JOB.Button_ChangeStatus_InProgress' : 'Úloha prebieha',
    'JOB.Button_ChangeStatus_Done' : 'Dokončiť úlohu',
    'JOB.Modal_Title_Photo' : 'Fotka úlohy',
    'JOB.Filter_Params_JobType' : 'Typ: { withFilter }',
    'JOB.Filter_Params_CraftType' : 'Práce: { withFilter }',
    'JOB.Modal_Title_NewJob' : 'Nový { jobType }',
    'JOB.Modal_Title_EditJob' : 'Upraviť { jobType }',
    'JOB.Button_Text_AddClaim' : 'Pridať úlohu MP reklamácie',
    'JOB.Button_Text_AddCustomerClaim' : 'Pridať úlohu reklamácie vystavovateľa',
    'JOB.Button_Text_AddLastMinute' : 'Pridať urgentnú úlohu',
    'JOB.Button_Text_AddDamage' : 'Pridať fotku škody',
    'JOB.Button_Text_AddProtocolDefect' : 'Pridať vadu protokolu',
    'DAMAGE.Card_Title' : 'Škody u { exhibitor }',
    'DAMAGE.Modal_Title_Photo' : 'Škody { exhibitor }',
    'DAMAGE.Status_Label_New' : 'Neskontrolované',
    'DAMAGE.Status_Label_Check' : 'Skontrolované',
    'DAMAGE.Status_Label_DCheck' : 'Schválené',
    'DAMAGE.Button_Text_Stand' : 'Stánok',
    'DAMAGE.Button_Text_Photo' : 'Fotka',
    'DAMAGE.Button_Text_AddNote' : "PRIDAŤ POZNÁMKU",
    'DAMAGE.Modal_Button_AddPhoto' : 'Pridať fotku',
    'DAMAGE.Modal_Button_CreateReport' : 'Vytvoriť report',
    'DAMAGE.Modal_Button_EditReport' : 'Upraviť report',
    'DAMAGE.AsCraft_label' : "Škody",
    "DAMAGE.Button_Text_Open" : "Otvoriť",
    "STAND.Block_Title_Damages" : "Škody",
    'MENUS.Label_Overview' : 'Prehľad',
    'MENUS.Label_Stands' : 'Stánky',
    'MENUS.Label_Jobs' : 'Úlohy',
    'MENUS.Label_ExpoPlan' : 'Plán expo',
    'MENUS.Label_More' : 'Viac',
    'MENUS.Label_SelectExhibition' : 'Vybrať podujatie',
    'MENUS.Label_CraftsOverview' : 'Prehľad prác',
    'MENUS.Label_HallsOverview' : 'Prehľad hál',
    'MENUS.Label_ViewDamages' : 'Zobraziť škody',
    'MENUS.Label_Downloads' : 'Súbory',
    'MENUS.Label_Documents' : 'Dokumenty',
    'MENUS.Label_FurnishingLeftovers' : 'Zvyšné vybavenie',
    'MENUS.Label_HelpImprint' : 'Imprint',
    'MENUS.Label_CollectGraphics' : 'Vyzdvihnúť grafiku',
    'NO_DATA.Exhibitions' : 'Zatiaľ nemáte žiadne podujatia.',
    'NO_DATA.Documents' : 'Aktuálne podujatie zatiaľ nemá { br } žiadne dokumenty.',
    'NO_DATA.Stands' : 'Stánky zodpovedajúce požiadavke { br } neboli nájdené',
    'NO_DATA.StandPhoto' : 'Zatiaľ nemáte fotku stánku',
    'NO_DATA.DamagePhoto' : 'Zatiaľ nemáte fotku škôd { br } tohto stánku',
    'NO_DATA.Stand_NoKeys' : 'Tento stánok zatiaľ nemá žiadne kľúče',
    'NO_DATA.Stand_DoesNotExist' : 'Tento stánok neexistuje',
    'NO_DATA.Subcontractor_Unsigned' : 'Nepriradené',
    'NO_DATA.Jobs' : 'Úlohy zodpovedajúce požiadavke { br } neboli nájdené',
    'NO_DATA.Damages' : 'Škody zodpovedajúce požiadavke { br } neboli nájdené',
    'NO_DATA.Hall' : 'Táto hala neexistuje',
    'NO_DATA.HallPlan' : 'Nenašli sme plán tejto haly',
    'NO_DATA.Furnishing_Storage' : 'Toto podujatie nemá { br } vybavenie v sklade',
    'NO_DATA.Furnishing_Orders' : 'Toto podujatie nemá { br } objednávky vybavenia',
    'PAGE.Title_Overview' : 'Prehľad',
    'PAGE.Title_ExhibitionSelection' : 'Výber podujatia',
    'PAGE.Title_Stands' : 'Stánky',
    'PAGE.Title_Stand' : 'Stánok',
    'PAGE.Title_StandComments' : 'Komentáre stánku',
    'PAGE.Title_StandLog' : 'Log stánku',
    'PAGE.Title_StandKeys' : 'Kľúče stánku',
    'PAGE.Title_ViewDamages' : 'Zobraziť škody',
    'PAGE.Title_AdditionalMenu' : 'Ďalšie menu',
    'PAGE.Title_Jobs' : 'Úlohy',
    'PAGE.Title_ExpoPlan' : 'Plán expo',
    'PAGE.Title_Documents' : 'Dokumenty',
    'PAGE.Title_FurnishingLeftovers' : 'LM vybavenie',
    'PAGE.Title_FurnishingReturns' : 'Záznam zmien vybavenia',
    'PAGE.Title_HallPlan' : 'Plán haly',
    'PAGE.Title_HallsOverview' : 'Prehľad hál',
    'PAGE.Title_CraftsOverview' : 'Prehľad prác',
    'PAGE.Title_HelpImprint' : 'Imprint',
    'PAGE.Title_CollectGraphics' : 'Vyzdvihnúť grafiku',
    'SORT.Text_NewestByCreation' : 'Najnovšie podľa dátumu vytvorenia',
    'SORT.Text_OldestByCreation' : 'Najstaršie podľa dátumu vytvorenia',
    'SORT.Text_ExhibitorNameAZ' : 'Názov vystavovateľa (A-Z)',
    'SORT.Text_ExhibitorNameZA' : 'Názov vystavovateľa (Z-A)',
    'SORT.Text_FinishedFirst' : 'Dokončené prvé',
    'SORT.Text_InProgressFirst' : 'Otvorené prvé',
    'SORT.Text_StandNumberAZ' : 'Číslo stánku (A-Z)',
    'SORT.Text_StandNumberZA' : 'Číslo stánku (Z-A)',
    'SORT.Text_CorridorAZ' : 'Koridor (A-Z)',
    'SORT.Text_CorridorZA' : 'Koridor (Z-A)',
    'SORT.Text_BlockAZ' : 'Blok (A-Z)',
    'SORT.Text_BlockZA' : 'Blok (Z-A)',
    'SORT.Text_FlagFirst' : 'S príznakom prvé',
    'SORT.Text_FlagLast' : 'Bez príznaku prvé',
    'SORT.Text_HallAZ' : 'Hala (A-Z)',
    'SORT.Text_HallZA' : 'Hala (Z-A)',
    'SORT.Text_StatusAZ' : 'Schválené',
    'SORT.Text_StatusZA' : 'Neskontrolované',
    'STAND.Modal_Title_Search' : 'Hľadať',
    'STAND.Input_Placeholder_Search' : 'Hľadať',
    'STAND.Filter_Params_Exhibitor' : 'Vystavovateľ: { exhibitorName }',
    'STAND.Filter_Params_WithComments' : 'S komentármi',
    'STAND.Card_Hero_Hall' : 'Hala',
    'STAND.Card_Hero_Block' : 'Blok',
    'STAND.Card_Hero_Stand' : 'Stánok',
    'STAND.Card_Hero_DeliveryTime' : 'Čas dodania',
    'STAND.Modal_Title_StandPlan' : 'Výkres stánku',
    'STAND.Modal_Button_StandPlan' : 'Výkres',
    'STAND.Card_Button_Details' : 'Detaily { icon }',
    'STAND.Modal_Title_StandPhoto' : 'Fotka stánku',
    'STAND.Modal_Button_StandPhoto' : 'Fotka',
    'STAND.Modal_Button_SavePhoto' : 'Uložiť fotku',
    'STAND.Modal_Button_AddPhoto' : 'Pridať fotku',
    'STAND.Button_Text_Comments' : 'Komentáre',
    'STAND.Button_Text_AddComment' : 'Pridať komentár',
    'STAND.Modal_Title_AddComment' : 'Pridať komentár',
    'STAND.Modal_Title_EditComment' : 'Upraviť komentár',
    'STAND.Modal_Button_AddComment' : 'Pridať',
    'STAND.Modal_Button_SaveComment' : 'Uložiť',
    'STAND.Text_NoComments' : 'Zatiaľ nie sú žiadne komentáre',
    'STAND.Text_AddFile' : 'Pridať súbor',
    'COMMENTS.Text_Uploading' : 'Nahrávanie...',
    'STAND.Text_EditComment' : 'Upraviť',
    'STAND.Text_DeleteComment' : 'Vymazať',
    'STAND.Text_CommentDraftError' : 'Koncept komentára ešte nie je pripravený',
    'STAND.Block_Title_Overview' : 'Prehľad',
    'STAND.Block_Title_Materials' : 'Dodatočné informácie',
    'STAND.Block_Title_Crafts' : 'Práce',
    'STAND.Block_ItemTitle_Hall' : 'Hala',
    'STAND.Block_ItemTitle_Block' : 'Blok',
    'STAND.Block_ItemTitle_Stand' : 'Stánok',
    'STAND.Block_ItemTitle_ProaufNumber' : 'Číslo Proauf',
    'STAND.Block_ItemTitle_Jobs' : 'Úlohy',
    'STAND.Block_Item_JobCountInProgress' : '{ jobCount } prebieha',
    'STAND.Block_Item_JobCountOpen' : '{ jobCount } otvorené',
    'STAND.Block_Item_JobCountFinished' : '{ jobCount } dokončené',
    'STAND.Block_Button_ViewStandJobs' : 'Zobraziť úlohy stánku',
    'STAND.Modal_Title_StandGraphic' : 'Grafika stánku',
    'STAND.Modal_Button_StandGraphic' : 'Grafika stánku',
    'STAND.Modal_Title_ExtraInfo' : 'Extra info',
    'STAND.Modal_Button_ExtraInfo' : 'Extra info',
    'STAND.Button_Text_ViewKeys' : 'Zobraziť kľúče',
    'STAND.Button_Text_ViewLogs' : 'Zobraziť logy',
    'STAND.Modal_Button_AddKey' : 'Pridať kľúč',
    'STAND.Modal_Title_AddKey' : 'Pridať kľúč',
    'STAND.Modal_Title_EditKey' : 'Upraviť kľúč',
    'STAND.Modal_Button_UpdateKey' : 'Aktualizovať kľúč',
    'STAND.Filter_Params_Stand' : 'Stánok { withFilter }',
    'STAND.Button_Text_DeleteKey' : 'Vymazať',
    'STAND.Text_ModalDelete_Question' : 'Naozaj chcete vymazať kľúč { keyName }?',
    'STAND.External_Exhibition' : 'Podujatie, ku ktorému nie ste priradení',
    'JOB.Button_Text_ViewPhoto' : 'Zobraziť fotku',
    'OVERVIEW_TYPES.Label_InTotal' : 'celkom',
    'OVERVIEW_TYPES.Label_Finished' : 'dokončené',
    'OVERVIEW_TYPES.Label_Open' : 'otvorené',
    'OVERVIEW_TYPES.Label_Claims' : 'reklamácie',
    'OVERVIEW_TYPES.Label_LastMinute' : 'urgentné',
    'OVERVIEW_TYPES.Label_Overdue' : 'po termíne',
    'FURNISHING.TabName_Storage' : 'Sklad',
    'FURNISHING.TabName_Refund' : 'Vrátenie',
    'FURNISHING.TabName_OrderLog' : 'Záznam objednávok',
    'FURNISHING.Modal_Title_ReturnFurnishing' : 'Množstvá LM vybavenia',
    'FURNISHING.Modal_Title_FurnishingStore' : 'Vybavenie v sklade',
    'FURNISHING.Button_Text_Return' : 'Vrátiť',
    'FURNISHING.Button_Text_ChooseFurnishing' : 'Vybrať vybavenie',
    'FURNISHING.Modal_Title_Photo' : "Fotka vybavenia",
    'FURNISHING.Order_Type_Refund' : "Vrátenie",
    'FURNISHING.Order_Type_Lost' : "Stratené",
    'FURNISHING.Order_Type_Correction' : "Oprava",
    'FURNISHING.Order_Type_Order' : "Objednávka",
};

export default slovak;
